import { useEffect } from "react";
import { useKomutStore } from "@lib/store";
import { resolveCountryMetadata } from "@utils/country-metadata";

interface CountryResponse {
  country?: string | null;
}

/**
 * Seeds the persisted `countryData` store guess for guests using the
 * `x-vercel-ip-country` header served by /api/geo. Authenticated users rely
 * on their profile country instead, so this only runs for guests.
 */
export function GuestCountryDetector() {
  const user = useKomutStore((s) => s.userInfo);
  const countryData = useKomutStore((s) => s.countryData);
  const setCountryData = useKomutStore((s) => s.setCountryData);

  useEffect(() => {
    if (user) return;
    if (countryData) return;

    let cancelled = false;

    fetch("/api/geo", {
      signal: AbortSignal.timeout(5000),
    })
      .then((res) => (res.ok ? (res.json() as Promise<CountryResponse>) : null))
      .then((data) => {
        if (cancelled || !data?.country) return;
        setCountryData(resolveCountryMetadata(data.country));
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, [user, countryData, setCountryData]);

  return null;
}